import type { Security, SecurityType } from 'app-components/flux/securities/securitiesTypes';

import type { DetailedQuote, QuotesSecurityType } from './investmentsQuotesDetailedTypes';

export const keyFromSymbolAndType = (symbol: string, securityType: QuotesSecurityType = 'STOCK'): string => {
  return `${securityType}:${symbol}:USD`;
};

export const keyFromQuote = (quote: DetailedQuote) => {
  return `${quote.securityType}:${quote.symbol}:${quote.currency}`;
};

export const keyFromSecurity = (security?: Security): string | undefined => {
  return security?.securityType && security?.symbol
    ? `${quoteTypeFromSecurityType(security?.securityType) || 'STOCK'}:${security?.symbol}:USD`
    : undefined;
};

export const keyFromHolding = (holding?: { symbol?: string }, securityType?: SecurityType): string | undefined => {
  return securityType && holding?.symbol
    ? `${quoteTypeFromSecurityType(securityType)}:${holding?.symbol}:USD`
    : undefined;
};

const securityTypeMapping: Record<SecurityType, QuotesSecurityType> = {
  STOCK: 'STOCK',
  MUTUALFUND: 'STOCK',
  SWEEP: 'STOCK',
  DEBT: 'STOCK',
  OPTION: 'STOCK',
  BOND: 'STOCK',
  CRYPTOCURRENCY: 'CRYPTOCURRENCY',
  OTHER: 'STOCK',
};
export const quoteTypeFromSecurityType = (securityType?: SecurityType): QuotesSecurityType =>
  securityTypeMapping[securityType || 'OTHER'] || 'STOCK';
